import { z } from "zod";

import { agendaItemSchema } from "../event-experience/schemas";

/**
 * An agenda item as the admin form edits it: the participant shape plus the
 * three landing page fields, which the form must read back to show and keep
 * them. Null reads like absent, the way the participant shape reads it, so the
 * two agree where an agenda component takes either. A malformed stored value
 * reads as absent, so one bad session cannot drop out of the list.
 */
export const adminAgendaItemSchema = agendaItemSchema.extend({
  highlight: z.boolean().nullable().optional().catch(undefined),
  highlightTitle: z.string().nullable().optional().catch(undefined),
  highlightBlurb: z.string().nullable().optional().catch(undefined),
});
export type AdminAgendaItem = z.infer<typeof adminAgendaItemSchema>;
